export default __webpack_public_path__ + "static/media/crossGrey.da995f24.svg";